//@author: travis
import { Component, Input, OnInit, signal, ChangeDetectionStrategy } from "@angular/core";
import { EChartsOption } from "echarts";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { Location } from "../../pojo/Location";
import Rating = Location.Rating;
import { UserprefService } from "../../services/userpref.service";
import { S25Datefilter } from "../s25-dateformat/s25.datefilter.service";
import { CallbackDataParams } from "echarts/types/dist/shared";

@TypeManagerDecorator("s25-ng-e-charts")
@Component({
    selector: "s25-ng-e-charts",
    template: `
        @if (init()) {
            <div>
                <div echarts [options]="chartOption"></div>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25EChartsComponent implements OnInit {
    @Input() roomData: Rating[];

    chartOption: EChartsOption = {};
    init = signal(false);

    async ngOnInit() {
        const datePref = await UserprefService.getS25Dateformat();

        this.chartOption = {
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                },
            },
            formatter: (params: CallbackDataParams[]) => {
                const score = this.roomData?.find((term) => term.termCode === params[0]?.name);
                if (score) {
                    return `<p style="font-size: 20px;">${score.termTitle}</p> Term Code: <br/> ${score.termCode} <br/> End Date: <br/> ${S25Datefilter.transform(score.endDt, datePref)} `;
                }
            },
            xAxis: {
                type: "category",
                boundaryGap: false,
                data: this.roomData?.map((term) => term.termCode) ?? [],
            },
            yAxis: {
                type: "value",
            },
            series: [
                {
                    data: this.roomData?.map((term) => term.ratingAvg) ?? [],
                    type: "line",
                    areaStyle: {},
                },
            ],
        };
        this.init.set(true);
    }
}
